export const NOT_DISCLOSED = "not_disclosed"
export const SINGLE = "single"
export const COUPLE = "couple"
